/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type AnalysisOverviewSharedWithMeStatus =
  (typeof AnalysisOverviewSharedWithMeStatus)[keyof typeof AnalysisOverviewSharedWithMeStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalysisOverviewSharedWithMeStatus = {
  shared_with_me: "shared_with_me",
} as const;
